export default "__VITE_ASSET__90385147__"